(function( $ ) {
		let creditCardNumField    = $( document.getElementById( 'checkout-card-number' ) ),
		    creditCardCsvField    = $( document.getElementById( 'checkout-card-csc' ) ),
		    acceptedCreditCards   = {
			    visa       : /^4[0-9]{12}(?:[0-9]{3})?$/,
			    mastercard : /^5[1-5][0-9]{14}$|^2(?:2(?:2[1-9]|[3-9][0-9])|[3-6][0-9][0-9]|7(?:[01][0-9]|20))[0-9]{12}$/,
			    amex       : /^3[47][0-9]{13}$/,
			    discover   : /^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$/,
			    diners_club: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
			    jcb        : /^(?:2131|1800|35[0-9]{3})[0-9]{11}$/
		    }, currentDate        = new Date(),
		    currentMonth          = currentDate.getMonth() + 1,
		    currentYear           = currentDate.getFullYear(),
		    ccMonth               = $( '#checkout-card-expiration-month' ),
		    ccYear                = $( '#checkout-card-expiration-year' ),
		    ccValError            = $( document.getElementById( 'credit-card-validation-msg' ) ),
		    ccValErrorTxt         = ccValError.find( 'span' ),
		    creditCardDateExpired = false;

		$( document ).ready( function() {
			'use strict';

			creditCardNumField.on( 'blur', triggerCCValidation );
			creditCardCsvField.on( 'blur', triggerCCValidation );

			//always checks year first, then month if necessary
			ccYear.on( 'change', checkYearExpiration );
			ccMonth.on( 'change', checkYearExpiration );
		} ); // doc ready

		function triggerCCValidation() {
			let numberValid = false, cvvValid = false;

			if ( validateCard( creditCardNumField.val() ) ) {
				numberValid = true;
			} else {
				numberValid = false;
			}

			if ( validateCVV( creditCardNumField.val(), creditCardCsvField.val() ) ) {
				cvvValid = true;
			} else {
				cvvValid = false;
			}

			if ( validateCard( creditCardNumField.val() ) && validateCVV( creditCardNumField.val(), creditCardCsvField.val() ) && !creditCardDateExpired ) {
				ccValErrorTxt.html( '' );

				$( 'button[type="submit"]' ).prop( 'disabled', false );

				ccValError.addClass( 'hidden' );
			} else {
				if ( creditCardNumField.val().length > 0 ) {
					if ( !numberValid ) {
						ccValError.removeClass( 'hidden' );
						ccValErrorTxt.html( 'Credit card number not valid.' );
					}
				}

				if ( creditCardCsvField.val().length > 0 ) {
					if ( !cvvValid ) {
						ccValErrorTxt.html( 'Credit card CVV is not valid.' );
						ccValError.removeClass( 'hidden' );
					}
				}

				$( 'button[type="submit"]' ).prop( 'disabled', true );
			}

			// store last value
			creditCardNumField.attr( 'data-lastvalue', creditCardNumField.val() );
		}

		function validateCard( value ) {
			// remove all non digit characters
			let ccNumber = value.replace( /\D/g, '' );
			let sum = 0;
			let shouldDouble = false;
			// loop through values starting at the rightmost side
			for ( let i = ccNumber.length - 1; i >= 0; i-- ) {
				let digit = parseInt( ccNumber.charAt( i ) );

				if ( shouldDouble ) {
					if ( (digit *= 2
					     ) > 9 ) {
						digit -= 9;
					}
				}

				sum += digit;
				shouldDouble = !shouldDouble;
			}

			let valid = (sum % 10
			            ) === 0;
			let accepted = false;

			// loop through the keys (visa, mastercard, amex, etc.)
			Object.keys( acceptedCreditCards ).forEach( function( key ) {
				let regex = acceptedCreditCards[ key ];
				if ( regex.test( ccNumber ) ) {
					accepted = true;
				}
			} );

			return valid && accepted;
		}

		function validateCVV( cc, cvv ) {
			// remove all non digit characters
			let creditCard = cc.replace( /\D/g, '' );
			let cvvNumber = cvv.replace( /\D/g, '' );
			// american express and cvv is 4 digits
			if ( (acceptedCreditCards.amex
				).test( creditCard ) ) {
				if ( (/^\d{4}$/
					).test( cvvNumber ) ) {

					return true;
				}
			} else if ( (/^\d{3}$/
				).test( cvvNumber ) ) { // other card & cvv is 3 digits

				return true;
			}

			return false;
		}

		/**
		 * Returns true if CC date is expired
		 * ( Checks Year, then month if year is not expired )
		 */
		function checkYearExpiration() {
			if ( ccYear.val() ) {
				if ( currentYear > parseInt( ccYear.val(), 10 ) ) {
					creditCardDateExpired = true;
					displayExpirationMessage();
				} else {
					checkMonthExpiration();
				}
			} else {
				//is NOT expired
				creditCardDateExpired = false;
				displayExpirationMessage();
			}
		}

		/**
		 * Returns true if CC date is expired
		 * ( Only checks month if the year is the same as current year )
		 */
		function checkMonthExpiration() {
			if ( ccYear.val() && ccMonth.val() ) {
				if ( currentYear === parseInt( ccYear.val(), 10 ) ) {
					if ( currentMonth > parseInt( ccMonth.val(), 10 ) ) {
						//month is expired within the same year
						creditCardDateExpired = true;
						displayExpirationMessage();
					} else {
						//is NOT expired
						creditCardDateExpired = false;
						displayExpirationMessage();
					}
				} else {
					//is NOT expired because year is good
					creditCardDateExpired = false;
					displayExpirationMessage();
				}
			}
		}

		function displayExpirationMessage() {
			if ( ccMonth.val() && ccYear.val() ) {
				if ( creditCardDateExpired ) {
					ccValErrorTxt.html( 'Credit card expired.' );

					ccValError.removeClass( 'hidden' );
					$( 'button[type="submit"]' ).prop( 'disabled', true );
				} else {
					ccValErrorTxt.html( '' );

					ccValError.addClass( 'hidden' );
					$( 'button[type="submit"]' ).prop( 'disabled', false );
				}
			}
		}
	}
)( jQuery );